module.exports = __webpack_public_path__ + "static/media/arrow-right.1f52850e.svg";